<template>
  <div
    :class="`relative-position overflow-hidden full-width rounded-borders-lg bg-${baseColor}`"
    :style="{ height: height }"
  >
    <div
      :class="`absolute-left full-height bg-${computedProgressColor}`"
      :style="{ width: `${progress}%` }"
    />
  </div>
</template>

<script>
export default {
  name: 'SAIProgress',
  props: {
    height: {
      type: String,
      default: '16px'
    },
    progress: {
      type: Number,
      default: 0
    },
    baseColor: {
      type: String,
      default: 'platinum'
    },
    progressColor: {
      type: String,
      default: 'primary'
    },
    exceeded: {
      type: Number,
      default: 100
    },
    exceededColor: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    computedProgressColor() {
      return this.progress > this.exceeded
        ? this.exceededColor
        : this.progressColor;
    }
  }
};
</script>
